/* eslint-disable react/prop-types */
import React from "react";
import CustomText from "./customText";
import { Colors } from "../assets/colors";

function MainHeader({ heading, headerStyle }) {
  return (
    <CustomText
      desc={heading}
      fontFamily="Epilogue"
      colorvalue={Colors.mainHeaderTxtColor}
      style={{ ...styles.mainHeaderTxt, ...headerStyle }}
      h0
      fontWeight={400}
    />
  );
}

const styles = {
  mainHeaderTxt: {
    lineHeight: 1.1,
    letterSpacing: "-0.01em",
    fontStyle: "initial",
    textAlign: "center",
    fontSize: {
      xs: "20px",
      sm: "28px",
      md: "32px",
      lg: "36px",
      xl: "40px"
    }
  },
};

export default MainHeader;
